import { useCallback } from 'react';
import { useDateRange, getDateRange } from '../../_commons/dateRange';
import { filtersReducer } from '../../_commons/filtersReducer';
import { useTrackingChange } from '../../../../_integrations/everymundo/tracking';
import { usePassengers } from '../hook/usePassengers';
import { useEffectReducer } from 'use-effect-reducer';
import { useTrackingChangeDatalayer } from '../../../../_integrations/everymundo/tracking/airlines';

export function useFilters({ popupData, prePopulation, datalayerTracking = false }) {
  const useTracking = () => {
    const trackingFn = datalayerTracking ? useTrackingChangeDatalayer : useTrackingChange;
    return trackingFn();
  };

  const track = useTracking();

  const tracking = useCallback(
    (_, event) => {
      track(event.prevState, event.action, _);
    },
    [track]
  );
  const [state, dispatch] = useEffectReducer(
    filtersReducer,
    {
      origin: { value: popupData.origin || '' },
      destination: { value: popupData.destination || '' },
      dateRange: getDateRange({ dateRange: {} }, { nextMonth: false }),
      passengers: prePopulation?.passengers || [1, 0, 0],
      flightType: popupData.journeyType,
      userInteraction: false
    },
    {
      tracking
    }
  );

  const passengers = usePassengers(dispatch, popupData.passengers);

  const dateRange = useDateRange({ dispatch, value: state.dateRange });

  return {
    dateRange,
    passengers,
    state,
    dispatch
  };
}
